<template>
  <div>
    <span
      v-for="({ locale }, index) of locales"
      :key="locale"
    >
      <span v-if="index !== 0">|</span>
      <v-btn
        :class="{ 'text--primary': locale === currentLocale }"
        icon
        @click="setLocale(locale)"
      >
        {{ locale }}
      </v-btn>
    </span>
  </div>
</template>


<script>
import localeMixin from '@/mixins/locale.mixin'


export default {
  mixins: [
    localeMixin
  ]
}
</script>
